module.exports = __webpack_public_path__ + "static/absolute_1-fb5c0eb53d9ac9e81f2cc1c0ed38a467.jpg";